import { Action } from '@ngrx/store';

export function getTileErrorsType<TModel>(module: string, type: { new(): TModel; }): string {
  return `[${module}] Tile Errors for ${(type as any).$typeName}`;
}

export class TileErrorsAction<TModel> implements Action {
  readonly type: string;

  constructor(module: string, modelType: { new(): TModel; }, public payload: { errors: string[] }) {
    this.type = getTileErrorsType(module, modelType);
  }
}



// WEBPACK FOOTER //
// ./src/app/pillar/dashboard/store/actions/TileErrorsAction.ts